<template>
  <div class="row row-equal">
    <div class="flex md12">
      <va-collapse>
        <span slot="header">Montrer les statistiques</span>
        <div slot="body">
          <div class="row">
            <div class="flex md3">
              <va-card class="mb-4" color="info">
                <p class="display-5 mb-2" style="color: white">
                  {{ nb_entreprises }} entreprises dans la base
                </p>
                <p class="display-7 mb-1" style="color: white">
                  {{ nb_active }} entreprises en activité
                </p>
                <p class="display-7 mb-1" style="color: white">
                  CCN (et assimilés): {{ ccn_active }}
                </p>
                <p class="display-7 mb-1" style="color: white">
                  Hors CCN: {{ hors_ccn_active }}
                </p>
                <p class="display-7 mb-1" style="color: white">
                  CCN inconnue: {{ ccn_inconnue_active }}
                </p>
                <p class="display-7 mb-1" style="color: white">
                  En liquidation: {{ nbliquidation }}
                </p>
                <p class="display-7 mb-1" style="color: white">
                  Fermées: {{ nbclosed }}
                </p>
              </va-card>
            </div>
            <div class="flex md3">
              <va-card class="mb-4" color="success">
                <p class="display-4 mb-1 text--center" style="color: white">
                  {{ nb_verifie }} entreprises vérifiées
                </p>
                <p class="display-4 mb-1 text--center" style="color: white">
                  {{ nb_entreprises - nb_verifie }} entreprises non vérifiées
                </p>
              </va-card>
            </div>
            <div class="flex md3">
              <va-card class="mb-4" color="success">
                <p class="display-4 mb-1" style="color: white">
                  {{ nb_OPEF }} adhérents OPEF
                </p>
                <div class="row row-separated">
                  <div class="flex xs6">
                    <p class="display-6 mb-0" style="color: white">
                      {{ nb_unpf }} UNPF
                    </p>
                    <p class="display-6 mb-0" style="color: white">
                      {{ nb_direct_unpf }} UNPF direct
                    </p>
                    <p class="display-6 mb-0" style="color: white">
                      {{ nb_opam }} OPAM
                    </p>
                    <p class="display-6 mb-0" style="color: white">
                      {{ nb_scapp }} SCAPP
                    </p>
                    <p class="display-6 mb-0" style="color: white">
                      {{ nb_languedoc }} Languedoc
                    </p>
                  </div>
                  <div class="flex xs6">
                    <p class="display-6 mb-0" style="color: white">
                      {{ nb_spef }} SPEF
                    </p>
                    <p class="display-6 mb-0" style="color: white">
                      {{ nb_direct_spef }} SPEF direct
                    </p>
                    <p class="display-6 mb-0" style="color: white">
                      {{ nb_agromer }} AGROMER
                    </p>
                    <p class="display-6 mb-0" style="color: white">
                      {{ nb_vendee }} Vendée
                    </p>
                    <p class="display-6 mb-0" style="color: white">
                      {{ nb_sdep }} S.D.E.P.
                    </p>
                  </div>
                </div>
              </va-card>
            </div>
            <div class="flex md3">
              <va-card class="mb-4" color="danger">
                <p class="display-4 mb-1 text--center" style="color: white">
                  {{ nb_ex_opef }} Ex-Adhérents
                </p>
                <div class="row row-separated">
                  <div class="flex xs6">
                    <p class="display-6 mb-0 text--center" style="color: white">
                      {{ nb_ex_unpf }} UNPF
                    </p>
                  </div>
                  <div class="flex xs6">
                    <p class="display-6 mb-0 text--center" style="color: white">
                      {{ nb_ex_spef }} SPEF
                    </p>
                  </div>
                </div>
              </va-card>
            </div>
          </div>
          <div class="row">
            <div class="flex md3">
              <va-card class="mb-4" color="warning">
                <p class="display-4 mb-2" style="color: white">
                  Protection juridique MAPA
                </p>
                <p class="display-5 mb-1" style="color: white">
                  {{ nb_mapa }} contrats en cours
                </p>
              </va-card>
            </div>
            <div class="flex md3">
              <va-card class="mb-4" color="info">
                <p class="display-4 mb-2" style="color: white">
                  Entreprises vérifiées:
                </p>
                <table style="width: 100%">
                  <template v-for="person in userlist">
                    <tr>
                      <th>{{ person.prenom }}</th>
                      <th>{{ person.nom }}</th>
                      <th>{{ person.nb_verif }}</th>
                    </tr>
                  </template>
                </table>
              </va-card>
            </div>
          </div>
        </div>
      </va-collapse>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { orderBy } from "lodash";

export default {
  name: "DashboardInfoBlock",
  data() {
    return {
      nb_entreprises: 0,
      nb_active: 0,
      nb_agromer: 0,
      nb_direct_spef: 0,
      nb_direct_unpf: 0,
      nb_ex_opef: 0,
      nb_ex_spef: 0,
      nb_ex_unpf: 0,
      nb_languedoc: 0,
      nb_vendee: 0,
      nb_sdep: 0,
      nb_mapa: 0,
      nb_OPEF: 0,
      nb_opam: 0,
      nb_scapp: 0,
      nb_spef: 0,
      nb_unpf: 0,
      nb_verifie: 0,
      userlist: [],
      ccn_active: 0,
      ccn_inactive: 0,
      hors_ccn_active: 0,
      hors_ccn_inactive: 0,
      ccn_inconnue_active: 0,
      ccn_inconnue_inactive: 0,
      nbliquidation: 0,
      nbclosed: 0,
    };
  },
  methods: {
    async init() {
      try {
        let res = await axios.get("/api/stats-entreprises");

        let data = res.data;
        this.nb_entreprises = data.nb_entreprises;
        this.nb_active = data.nb_active;
        this.nb_agromer = data.nb_agromer;
        this.nb_direct_spef = data.nb_direct_spef;
        this.nb_direct_unpf = data.nb_direct_unpf;
        this.nb_ex_opef = data.nb_ex_opef;
        this.nb_ex_spef = data.nb_ex_spef;
        this.nb_ex_unpf = data.nb_ex_unpf;
        this.nb_languedoc = data.nb_languedoc;
        this.nb_vendee = data.nb_vendee;
        this.nb_sdep = data.nb_sdep;
        this.nb_mapa = data.nb_mapa;
        this.nb_OPEF = data.nb_OPEF;
        this.nb_opam = data.nb_opam;
        this.nb_scapp = data.nb_scapp;
        this.nb_spef = data.nb_spef;
        this.nb_unpf = data.nb_unpf;
        this.nb_verifie = data.nb_verifie;
        //TODO order by best results
        this.userlist = orderBy(data.userlist.slice(0, 5), "nb_verif", "desc");
        let resnew = await axios.get("/api/stats-menu");
        this.nb_entreprises = resnew.data.nbentreprise;
        this.ccn_active = resnew.data.ccn_active;
        this.ccn_inactive = resnew.data.ccn_inactive;
        this.hors_ccn_active = resnew.data.hors_ccn_active;
        this.hors_ccn_inactive = resnew.data.hors_ccn_inactive;
        this.ccn_inconnue_active = resnew.data.ccn_inconnue_active;
        this.ccn_inconnue_inactive = resnew.data.ccn_inconnue_inactive;
        this.nbliquidation = resnew.data.nbliquidation;
        this.nbclosed = resnew.data.nbclosed;
      } catch (err) {
        console.log(err);
      }
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style lang="scss">
.row-separated {
  .flex + .flex {
    border-left: 1px solid #e3eaeb;
  }

  @include media-breakpoint-down(xs) {
    p:not(.display-2) {
      font-size: 0.5rem;
    }
  }
}

.dashboard {
  .va-card__header--over {
    @include media-breakpoint-up(md) {
      padding-top: 0 !important;
    }
  }

  .va-card__image {
    @include media-breakpoint-up(md) {
      padding-bottom: 0 !important;
    }
  }
}
</style>
